import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

import { Division } from '../utils/models';
import { AppDispatch, RootState } from './configureStore';

import * as service from '../services/divisionService';
import * as utils from '../utils/utilities';

interface DivisionState {
	loading: boolean;
	error: boolean;
	lastUpdated: null | number;
	list: Division[];
}

const initialState: DivisionState = {
	loading: false,
	error: false,
	lastUpdated: null,
	list: [],
};

const slice = createSlice({
	name: 'divisions',
	initialState,
	reducers: {
		divisionsRequested: (divisions) => {
			divisions.loading = true;
		},
		divisionsRequestSuccess: (divisions, action) => {
			divisions.list = action.payload;
			divisions.loading = false;
			divisions.error = false;
		},
		divisionsRequestFailed: (divisions) => {
			divisions.loading = false;
			divisions.error = true;
		},
		updateSyncTime: (divisions) => {
			divisions.lastUpdated = Date.now();
		},
	},
});

export const loadDivisions = () => async (dispatch: AppDispatch) => {
	try {
		dispatch(slice.actions.divisionsRequested());
		const result = await service.getAllDivisions();
		dispatch(slice.actions.divisionsRequestSuccess(result.data.division));
	} catch (ex) {
		const cachedDivisions = utils.getCachedDataFromException(ex);
		if (!cachedDivisions) {
			return dispatch(slice.actions.divisionsRequestFailed());
		}

		dispatch(slice.actions.divisionsRequestSuccess(cachedDivisions));
	}
};

export const getDivisions = createSelector(
	(state: RootState) => state,
	(state) => state.divisions
);

export default slice.reducer;
